export const fieldsInfo: any = {

  // fields with quartered cell size
  quarteredSizeFields: [
    'code',
    'sub_group_code',
    'sub_group_item_count',
  ],

  halfSizeFields: [
    'name',
    'sub_group_name',
  ],

  // fields with full cell size
  fullSizeFields: [
    'description',
  ],

  // input fields
  inputFields: [
    'name',
    'code',
    'description',
    'sub_group_name',
    'sub_group_code',
  ],

  readonlyFields: [
    'sub_group_item_count',
  ],

};
